export default "__VITE_ASSET__Bz4DG7Es__"